<template>
    <div v-if="babyInfo.tag_id>'1'" :class="babyInfo.sex=='M'?'swiper-slide header_main header_baby header_man':'swiper-slide header_main header_baby header_woman'">
        <!-- <div><span class="title"></span><span class="text">我的宝宝</span></div> -->
        <div class="header_top">
            <div class="avatar" :style="{backgroundImage:'url('+(babyInfo.pic?babyInfo.pic:babyInfo.sex=='M'?manHead:womanHead)+')'}"></div>
            <div class="name">{{(babyInfo.nick && babyInfo.nick!='')? babyInfo.nick:'鹤小宝'}}</div>
            <div class="growth">性别：{{babyInfo.sex == 'M' ? '男':babyInfo.sex == 'O'||babyInfo.sex == '' ?'未知':'女'}}</div>
            <div class="birthdays">生日：{{(babyInfo.birth && babyInfo.birth != '')? formateDate:'未知'}}</div>
            <div class="month_age" v-if="babyDays!=null">月龄：{{babyInfo.num==1?babyDays.firsttime:babyDays.secondtime}}</div>
        </div>
        <!-- <p class="dashedLine"></p> -->
        <!-- <div class="header_bottom" @click="tobaby"><img :src="babyInfo.sex=='M'?manMilk:womanMilk">宝宝粮仓：{{milkAmount ==0 || (milkAmount && milkAmount!='')?milkAmount+'g':'暂无'}}</div> -->
        <!-- <div class="exchange" @click.stop="toBabyGrowthRecord('成长记录')"><img v-if="babyInfo.sex!='M'" src="../../assets/images/Profile/profile/man1.png" alt=""><img src="../../assets/images/Profile/profile/man2.png" v-if="babyInfo.sex=='M'" alt=""> 成长曲线</div> -->
        <!-- <div class="sign" @click.stop="editBabyInfo('填写宝宝信息',babyInfo)">
            <span>
                <p>填写宝宝信息</p>
            </span>
        </div> -->
    </div>
</template>
<style lang="less" scoped>
.header_main{// 轮播图的外边框盒子(swiper-slide溢出隐藏)
    height: 138px;
    overflow: hidden;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    border-radius:8px;
}
.header_man{// 男宝的内部样式
    background-image: url('../../../assets/images/tools/babyCard/manbg.png');
    // .title{
    //     background:linear-gradient(180deg,rgba(158,163,255,1) 0%,rgba(149,155,255,1) 100%);
    // }
    // .text{
    //     color: #6C71ED;
    // }
    .name{
        color: rgba(108,113,237,1);
        // color:rgba(146,150,255,1);
    }
    .growth,.birthdays,.month_age{
        color:rgba(93, 89, 123, 1);
        // color:rgba(146,150,255,1);
    }
    .exchange{
        background:rgba(158,163,255,1);
        box-shadow:0px 1px 4px -2px rgba(127,127,220,1);
    }
    .header_bottom{
        color: rgba(93,89,123,1);
        // background-image: url(../../assets/images/Profile/profile/milk1.png);
    }
}
.header_woman{
    background-image: url('../../../assets/images/tools/babyCard/womanbg.png');
    // .title{
    //     background:linear-gradient(180deg,rgba(255,158,158,1) 0%,rgba(255,149,149,1) 100%);
    // }
    // .text{
    //     color: #ED6C6C;
    // }
    .name{
        color:rgba(237,108,108,1);
        // color:rgba(255,155,155,1);
    }
    .growth,.birthdays,.month_age{
        color:rgba(123, 89, 89, 1);
        // color:rgba(255,155,155,1);
    }
    .exchange{
        background:rgba(255,148,148,1);
        box-shadow:0px 1px 4px -2px rgba(220,127,127,1);
    }
    .header_bottom{
        color: rgba(123,89,89,1);
        // background-image: url(../../assets/images/Profile/profile/milk2.png);
    }
}
.header_baby{// 宝宝的公共样式
    .title{
        border-radius:5px 0px 8px 0px;
        font-size: 11px;
        font-weight: 400;
        line-height: 16px;
        width: 65px;
        text-align: center;
        opacity:0.31;
        display: block;
        height: 20px;
        position: relative;
    }
    .text{
        position: absolute;
        top: 0;
        padding-left: 9px;
        padding-top: 2px;
    }
    .header_top{
        width: calc(100% - 34px);
        position: absolute;
        top: 24px;
        left: 17px;
        .avatar{
            width: 94px;
            height: 94px;
            border-radius: 50%;
            float: left;
            // background-color:#00ff00;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: cover;
        }
        .name{
            font-size:@indexFontSize16;
            // font-weight: 600;
            margin-left: 14px;
            max-width: 120px;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            float: left;
            // display: block;
            margin-top: -6px;
        }
        .growth{
            font-size:@indexFontSize14;
            font-weight: 400;
            position: absolute;
            top: 22px;
            left: 109px;
        }
        .birthdays{
            font-size:@indexFontSize14;
            font-weight: 400;
            position: absolute;
            top: 50px;
            left: 109px;
        }
        .month_age{
            font-size:@indexFontSize14;
            font-weight: 400;
            position: absolute;
            top: 79px;
            left: 108px;
        }
    }
    .dashedLine{
        width:calc(100% - 34px);
        height: 1px;
        position: absolute;
        top:96px;
        left:17px;
        margin: 0;
        border-top: 1px dashed #A89191; 
    }
    .header_bottom{
        position: absolute;
        bottom: 22px;
        left: 17px;
        font-size: @indexFontSize14;
        // padding-left: 20px;
        background-position: center left;
        background-repeat: no-repeat;
        background-size: 12px auto;
        img{
            width: 12px;
            height: 18px;
            margin-right: 6px;
            position: relative;
            top: 2px;
        }
    }
    .exchange{
        width: 113px;
        height: 30px;
        position: absolute;
        bottom: 15px;
        right: 16px;
        border-radius:16px;
        font-size: @indexFontSize15;
        color: @expertFontColor255;
        line-height: 31px;
        text-align: center;
        img{
            width: 17px;
            margin-right: 2px;
            vertical-align: middle;
            padding-bottom: 3px;
        }
    }
    .sign{
        position: absolute;
        right: 19px;
        top: 34px;
        border:1px solid rgba(153,153,153,1);
        border-radius: 14px;
        font-size: @indexFontSize12;
        p{
            padding: 2px 8px;
            padding-top: 3px;
            line-height: 18px;
            color: @expertFontColor153;
        }
    }
}
</style>
<script>
import { getBabyAge } from '@/assets/js/common.js'
export default {
    name:"growthArchivesBabyCard",
    data() {
        return {
            babyNum:'', //宝宝胎次
            manHead:require('../../../assets/images/Profile/profile/manhead.png'), // 男宝默认头像
            womanHead:require('../../../assets/images/Profile/profile/womanhead.png') ,// 女宝默认头像
            manMilk:require('../../../assets/images/Profile/profile/milk1.png'),
            womanMilk:require('../../../assets/images/Profile/profile/milk2.png'),
        }
    },
    props:{
        babyInfo:{
            default:null,
            type: Object
        },
        milkAmount:{
            default: 0,
            type:Number
        },
        babyDays:{
            type: Object,
            default:{}
        }
    },
    computed: {
        formateDate() {
            var bir = this.babyInfo.birth.split('-')
            return `${bir[0]}年${bir[1]}月${bir[2]}日`
        },
        formateBir() {
            var monthAge = getBabyAge(this.babyInfo.birth,new Date())
            return monthAge
        }
    },
    mounted(){
        
    },
    methods:{
        /*
         // 个人中心流量位点击埋点GIO
        toBabyGrowthRecord:function(name){
            gio('track', 'userCenterCount',{'position_var':name});
            localStorage.setItem('growth_source','个人中心')
            this.babyNum = this.babyInfo.num
            this.babySex = this.babyInfo.sex
            this.$router.push({
                path:'/growthRecord',
                query:{
                    num:this.babyNum,
                }
            })
        },
        editBabyInfo:function(name,babyInfo){
            gio('track', 'userCenterCount',{'position_var':name});
            sensors.track('AddBabyInfo',{
                page_name:this.$route.meta.title,
                baby_name:babyInfo.nick,
                baby_gender:babyInfo.sex,
                baby_birthday:babyInfo.birth,
            })
            setTimeout(function(){
                // 使用location跳转解决宝宝头像点击上传报错问题
                location.href='mine/editBaby?num='+babyInfo.num+'&id='+babyInfo.tag_id
                // this.$router.push({
                //     path:'/mine/editBaby',
                //     query:{
                //         num:babyInfo.num,
                //     }
                // })
            },500)
        },
        tobaby:function(){
            this.$router.push({path:'/babyGranary'})
        },
        // 获取宝宝出生日期
        // getbabyBith: function() {
        //     this.$http.get("/parentingTips/getbabyBith",{ dayBith: this.babyInfo.birth },res => {
        //         if (res.code === "200") {
        //             this.userTipsInfo = res.data;
        //         }
        //     });
        // },
        */
    }
}
</script>
